

export const DEVICE = {
  JUDGE: "judge",
  MONITOR: "monitor",
  CHAIRPERSON: "chairperson",
  LED: "led",
  MC: "mc",
  DJ: "dj",
  FLOOR_MANAGER: "floor_manager",
  TRAINING: "training",
} as const;

export default DEVICE;
type t = typeof DEVICE;
export type DeviceType =  t[keyof t];

/**
 * A phone used by an adjudicator - the only kind that announces a judge to
 * marX. Installs from before device types restore no type at all, and those
 * were judge phones.
 */
export const isJudgeDeviceType = (deviceType?: DeviceType | null): boolean =>
  !deviceType || deviceType === DEVICE.JUDGE;
